module.exports = __webpack_public_path__ + "static/media/rewards_card_bg.10ac58a3.png";